import { cva } from 'class-variance-authority';
import styles from '../styles.module.scss';

export const stackVariants = cva(styles.stack, {
  variants: {
    direction: {
      row: styles.row,
      column: styles.column,
    },
    spacing: {
      0: styles.spacing0,
      2: styles.spacing2,
      4: styles.spacing4,
      6: styles.spacing6,
      8: styles.spacing8,
      12: styles.spacing12,
      16: styles.spacing16,
      20: styles.spacing20,
      24: styles.spacing24,
      32: styles.spacing32,
      40: styles.spacing40,
      48: styles.spacing48,
      56: styles.spacing56,
      72: styles.spacing72,
      88: styles.spacing88,
      104: styles.spacing104,
      120: styles.spacing120,
    },
  },
  defaultVariants: {
    spacing: 0,
    direction: 'column',
  },
});
